module.exports = __webpack_public_path__ + "img/btn_betsize.edf91bc3.png";